<template>
    <el-row :gutter="30"  class="mw-100 manage-footer-paragraph" >
        
        <el-col :lg="24" :xs="24">
            <el-card>
                <el-form
                    class="text-center font-24" 
                    ref="addParentFooterParagraphRef"
                    :model="currentFooterParagraphData"
                    :rules="currentFooterParagraphDataRules"
                    label-position="top"
                >
                    <el-row :gutter="30">
                        <el-col :lg="24" :xs="24">
                            <el-form-item>
                                <el-button type="primary" @click="manageFooterParagraph('addFooterParagraphRef')" class="text-cap">
                                    <font-awesome-icon :icon="['fas', 'floppy-disk']" style="width:20px" class="mr-10" />
                                    save
                                </el-button>
                            </el-form-item>
                        </el-col>
                        
                    </el-row>
                </el-form>
                <el-tabs  tab-position="left">
                    <el-tab-pane  v-for="(item, index) in currentFooterParagraphData.translates" :key="index" >
                        <template #label>
                            <span class="custom-tabs-label">
                                <span>
                                    {{$getLanguageName(item.languageID)}}
                                </span>
                            </span>
                        </template>
                        <el-form 
                            class="text-center font-24" 
                            ref="addFooterParagraphRef"
                            :model="currentFooterParagraphData"
                            :rules="currentFooterParagraphDataRules"
                            label-position="top"
                        >
                            <el-row :gutter="30">
                               
                                <el-col :lg="24" :xs="24">
                                    <el-form-item  label="title" :prop="`translates[${index}].title`" :class="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? 'text-right':''">
                                        <el-input type="text" v-model="currentFooterParagraphData.translates[index].title"></el-input>    
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :xs="24">
                                    <el-form-item  label="description" :prop="`translates[${index}].description`" :class="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? 'text-right':''">
                                        <ckeditor class="w-100" :editor="editor" v-model="currentFooterParagraphData.translates[index].description" :config="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? editorConfigAr :editorConfig "></ckeditor>
                                    </el-form-item>
                                </el-col>
                               
                                
                            </el-row>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>
            </el-card>
        </el-col>
    </el-row>
    
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
export default {
    data(){
        return {
            editor: ClassicEditor,
            editorData: '<p>Content of the editor.</p>',
            editorConfig: {
               
                // The configuration of the editor.
            },
            editorConfigAr: {
                language: {
                    // The UI will be English.
                    ui: 'ar',

                    // But the content will be edited in Arabic.
                    content: 'ar'
                }
            },
            isAddFooterParagraph:true,
            currentFooterParagraph:[],
            fileList:[],
            dialogVisible:false,
            dialogImageUrl:'',
            fileUploaded:false,

            currentFooterParagraphData:{},
            currentFooterParagraphDataRules:{
                value:{
                    required:true,
                    message:'required field',
                    trigger:'blur',
                },
                translates:this.$setTranslateRules(['title','description']),
            }
        };
    },
    computed:{
        cachedFooterParagraph(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website?.settings?.footer?.footerParagraphs.currentFooterParagraph || {}
        }
    },
    mounted(){
        this.isAddFooterParagraph = false;
        this.currentFooterParagraphData = JSON.parse(JSON.stringify(this.cachedFooterParagraph))
        this.currentFooterParagraphData.translates = this.$filterPublishedTranslates(this.currentFooterParagraphData.translates)
    },
    
    methods:{
        initState(){
            return {
                translates:this.$setTranslateKeys({
                    'title':'',
                    'description':'',
                })
            }
        },
       
        async manageFooterParagraph(formName){
            let successForm = [];
            for (let index = 0; index < this.$refs[formName].length; index++) {
                const element = this.$refs[formName][index];
                element.validate(async (valid) => {
                    if (!valid) {
                        this.$message({
                            message:`please fill the data in the ${this.$getOrderName(index + 1)} tab `,
                            type:'info',
                            duration:5000,
                            showClose: true,
                        });
                    }
                }).then(data =>{
                    let indexOfIndex = successForm.indexOf(index);
                    if (data){
                        successForm.push(index);
                        if (successForm.length == this.$refs['addFooterParagraphRef'].length){
                            this.manageFooterParagraphAfterValidate()
                        }
                    }else{
                        if(indexOfIndex != -1) {
                            successForm.splice(indexOfIndex,1);
                        }
                    }
                })  
            }
           
            
            
            
            
            
        },
        async manageFooterParagraphAfterValidate(){
            
            const response = await this.$store.dispatch(this.isAddFooterParagraph ? 'addFooterParagraph':'updateFooterParagraph',this.currentFooterParagraphData);
            if (response.data.status == 1) {
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                });
                await this.$store.dispatch('getFooterParagraph');
                this.$router.push({
                    name:'footer-paragraphs-list'
                })
            }
        },
        onUploadImage(file){
            if((file.size / Math.pow(1024, 2)).toFixed(2) * 1 > 5){
                this.$notify({
                    title:'File Size Exceded',
                    message:'the file uplaoded should be less than 5 MB',
                    type:'warning',
                });
                this.$refs['imageBase64'][0].clearFiles()
            }else{  
                const FR = new FileReader();
                let module = this;
                FR.addEventListener("load", function(evt) {
                    module.currentFooterParagraphData.imageBase64 = evt.target.result;
                }); 
                this.currentFooterParagraphData.imageURL =  URL.createObjectURL(file.raw);

                FR.readAsDataURL(file.raw);
            }
        },    
        handleRemoveImage(){
            this.currentFooterParagraphData.imageURL = this.isAddFooterParagraph ? '' : this.cachedFooterParagraph.imageURL
        }, 
       
    }
}
</script>
<style lang="scss">
    .manage-footer-paragraph {
        .ck-editor {
            width:100%;
        }
    }
</style>